import { Grid } from "@mui/material";
import { FormTextField } from "../form-elements/FormTextField";

export const GeneralInquiryForm = ({ formData, handleChange }) => (
  <Grid container spacing={3} style={{ justifyContent: "center" }}>
    <Grid item xs={12}>
      <FormTextField
        label="Full Name"
        name="name"
        value={formData.name}
        onChange={handleChange}
        required
        placeholder="Full Name"
      />
    </Grid>
    <Grid item xs={12}>
      <FormTextField
        label="Email"
        name="email"
        type="email"
        value={formData.email}
        onChange={handleChange}
        required
        placeholder="Enter your email so we can reach you if needed"
      />
    </Grid>
    <Grid item xs={12}>
      <FormTextField
        label="Message"
        name="message"
        multiline
        rows={4}
        placeholder="Write of message here..."
        value={formData.message}
        onChange={handleChange}
        required
      />
    </Grid>
  </Grid>
);
